import { render, staticRenderFns } from "./TrianglePointerIcon.vue?vue&type=template&id=27aff876&"
import script from "./TrianglePointerIcon.vue?vue&type=script&lang=js&"
export * from "./TrianglePointerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports